export const  bonusTypes = {
  EMISSION: 'Эмиссия со счета астера',
  REMISSION: 'Ремиссия на счет астера',
  EXPIRE: 'Истек срок действия бонусов',
  SUPPORT_ADDED: 'Добавлено через админку пользователю',
  EARN: 'Начисление бонусов астером',
  TRANSFER_IN: 'Поступление от другого пользователя',
  TRANSFER_OUT: 'Отправка другому пользователю',
  FROZEN: 'Заморожены',
  FROZEN_ASTER: 'Заморожеyные на счете астера',
  UNFROZEN: 'Разморозка у пользователя',
  UNFROZEN_ASTER: 'Разморозка на счете астера',
  SPEND: 'Потрачено пользователем',
  SUPPORT_DEDUCTED: 'Списано через админку у пользователя',
  SUPPORT_TRANSFER_IN: 'Поступление от другого пользователя через админку',
  SUPPORT_TRANSFER_OUT: 'Отправка другому пользователю пользователя через админку',
}

export const forWhat = {
  CP: 'Выкуп авто',
  CS_AMP: 'Продажа авто с пробегом',
  CS_AMP_1: 'Продажа авто с пробегом',
  CS_AMP_SEP_25: 'Продажа авто с пробегом',
  CS_NEWAUTO: 'Продажа нового авто',
  KOLESA_2024_07_24: 'Прочее',
  'Old Work List': 'Старый клиент',
}
